// WaiverModal.jsx
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";

export default function WaiverModal({ show, onAgreed }) {
    const [waiver, setWaiver] = useState(null);
    const [sigPad, setSigPad] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            axios.get("/api/leagues/waiver/").then((r) => setWaiver(r.data));
        }
    }, [show]);

    const handleAccept = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("waiver", waiver.id);
        await axios.post("/api/leagues/waiver/sign/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        setLoading(false);
        onAgreed();
    };

    if (!waiver) return null;

    return (
        <Modal show={show} size="lg" backdrop="static">
            <Modal.Header>
                <Modal.Title>{waiver.title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    dangerouslySetInnerHTML={{ __html: waiver.body }}
                    style={{ maxHeight: "40vh", overflowY: "auto" }}
                />

            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" disabled={loading} onClick={() => sigPad.clear()}>
                    Clear
                </Button>
                <Button variant="primary" disabled={loading} onClick={handleAccept}>
                    {loading ? "Saving..." : "I Agree"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
